<template>
    <!-- PC -->
    <div v-if="!mobile">
        <div>
            <div class="lkt-manual env_VN">
                <div><img src="/static\images\vi\newManual\courseConditionsManual-1.png" alt="" /></div>
                <div>
                    <p>① Nhấn vào icon [Tình hình học tập] trên thanh tiêu đề, chọn thanh [Tình trạng khóa học] để xem các tiến độ các khóa học bạn đã tham gia.</p>
                    <p>&nbsp; Chẳng hạn, ngày bắt đầu học, ngày hoàn thành, số bài học, …</p>
                </div>
                <div><img src="/static\images\vi\newManual\courseConditionsManual-2.png" alt="" /></div>
                <div>
                    <p>&nbsp; Các thông tin cần biết về một khóa học như: tên khóa học, ngày bắt đầu học, ngày hoàn thành (ngày hoàn thành nội dung của tất cả các bài học), số bài học, tiến độ…</p>
                    <p>※ Các khóa học được hiển thị trong bảng số liệu không bao gồm các khóa học đã kết thúc (tức những khóa học bạn đã học xong và đã gửi [Yêu cầu kết thúc]).</p>
                    <p>Lúc này, nút [Gồm cả khóa học đã hoàn thành] ở trạng thái chưa được kích hoạt.</p>
                </div>
                <div><img src="/static\images\vi\newManual\courseConditionsManual-3.png" alt="" /></div>
                <div>
                    <p>Khi kích hoạt nút [Gồm cả khóa học đã hoàn thành], thì trong danh sách sẽ xuất hiện cả những khóa học đã gửi [Yêu cầu kết thúc].</p>
                </div>
            </div>
        </div>
    </div>
    <!-- Mobile -->
    <div v-else>
        <div>
            <div class="lkt-manual env_VN">
                <div><p>① Nhấn icon [Tình trạng khóa học] ở phía dưới màn hình sẽ xuất hiện ô [Tình trạng khóa học], [Thành tích học tập].</p></div>
                <div><img src="/static\images\vi\newManual\mobile\course_status_1.png" alt="" /></div>
                <div><p><b>❖ Nhấn vào ô [Tình trạng khóa học] sẽ hiển thị cho bạn thông tin tình trạng các khóa học bạn đang tham gia.</b></p></div>
                <div><img src="/static\images\vi\newManual\mobile\course_status_course_status_1.png" alt="" /></div>
                <div><p>② Bạn muốn tìm kiếm khóa học nhập tên khóa học ô tìm kiếm và nhấn nút [tìm kiếm].</p></div>
                <div><p>③ Khi nhấn vào nút [Gồm cả khóa học hoàn thành] sẽ hiển thị những khóa học mà bạn đã yêu cầu kết thúc khóa học.</p></div>
                <div><p>④ Hiển thị danh sách các khóa học bạn đang tham gia.</p></div>
                <div><img src="/static\images\vi\newManual\mobile\course_status_course_status_2.png" alt="" /></div>
                <div><p>⑤ Khi chọn vào sẽ hiển thị thông [Ngày bắt đầu học], [Ngày hoàn thành], [Số chương], [Tiến độ], [Bảng khảo sát], [Bảng cam kết], [Chứng chỉ] của khóa học. Bạn muốn vào học thì bạn có thể nhấn nút [Tham gia] để vào học.</p></div>
                <div><p>● Ngày bắt đầu học: Ngày bạn tham gia khóa học.</p></div>
                <div><p>● Ngày hoàn thành: Ngày bạn hoàn thành khóa học đó.</p></div>
                <div><p>● Số chương: Tổng số chương của khóa học.</p></div>
                <div><p>● Tiến độ: Tỉ lệ phần trăm bạn  học trong khóa học.</p></div>
                <div><p>● Chứng chỉ: Khi bạn yêu cầu kết thúc khóa học sẽ hiển thị chứng chỉ tại đây.</p></div>
                <div><img src="/static\images\vi\newManual\mobile\course_status_course_status_3.png" alt="" /></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {};
        },
        components: {},
        computed: {
            mobile() {
                return this.$store.getters["header/mobile"];
            },
        },
        async created() {},
        watch: {},
        methods: {
            scrollToElement(id) {
                let element = document.getElementById(id);
                element.scrollIntoView();
            },
        },
    };
</script>
<style scoped>
    .lkt-manual div {
        margin-bottom: 10px;
    }
    .lkt-manual p {
        line-height: 25px;
    }
    .lkt-manual ul {
        margin-left: 20px;
        list-style: square;
        font-size: 12pt;
    }
    ul li {
        cursor: pointer;
    }
    img {
        width: 100%;
    }
    p {
        font-size: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/components/manual/content/vi/studySituationList_manual.vue